import React from "react";
import "./AppointmentsOverview.css";

const AppointmentsOverview = () => {
  const cardsData = [
    {
      title: "Appointments (7d)",
      value: "228",
      subtitle: "vs last week +6%",
    },
    {
      title: "No-show / reschedule rate",
      value: "9.4%",
      subtitle: "of scheduled appointments",
    },
    {
      title: "Physical vs virtual",
      value: "88% physical",
      subtitle: "12% virtual/telehealth",
    },
    {
      title: "Avg facility utilization",
      value: "—",
      subtitle: "blocked — see Facility Utilization tab",
    },
  ];

  return (
    <div className="appointments-overview-container">
      <h2 className="appointments-overview-title">Appointments overview</h2>
      <div className="appointments-overview-cards-grid">
        {cardsData.map((card, index) => (
          <div className="appointments-overview-card" key={index}>
            <h4 className="appointments-overview-card-title">{card.title}</h4>
            <div className="appointments-overview-card-value-container">
              <h2 className="appointments-overview-card-value">{card.value}</h2>
            </div>
            <div className="appointments-overview-card-subtitle">
              {card.subtitle}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AppointmentsOverview;
